// This function takes in the googleTagSettings defined in the builder file and transforms it into the format that is expected by the database
// reference googleTagSettings schema in packages/builder-server/src/services/builder/validation/syncInjector/validateGoogleGtagSettings.ts

const transformGoogleTagSettingsForDb = googleTagSettings => {
  if (!googleTagSettings) {
    return null;
  }

  return {
    tagId: googleTagSettings.tagID,
    loadGtag: googleTagSettings.loadGtag,
    loadWhenConsentDenied: googleTagSettings.consent.loadWhenConsentDenied,
    refreshOnEmptyHash: googleTagSettings.refreshOnEmptyHash ?? false,
    vtcEnabled: googleTagSettings.vtcEnabled ?? false,
    gtgEnabled: googleTagSettings.gtgEnabled ?? false,
    gtgScriptSource: googleTagSettings.gtgScriptSource ?? null,
    egsm: googleTagSettings.egsm ?? null,
  };
};

export default transformGoogleTagSettingsForDb;
